// Global
import React, {useContext, useState } from 'react';

// Local
// @ts-ignore
import { UserContext } from "../../Contexts/UserContext/UserContext"
// @ts-ignore
import {SectionProps} from './helpers.js'
// Antd
import {
	ContainerFilled,
} from '@ant-design/icons';
import { Menu } from 'antd';
// @ts-ignore
import { CubeIcon, CubesIcon, SeedlingIcon, PaperPlaneIcon, FireFlameIcon, WalletFireIcon, ShieldIcon } from '../../helpers/svgToIcon.js';


export const MenuAdminSection: React.FC<SectionProps & { }> = ({ selectedKey, onItemSelect }) => {

    const [isOpen, setIsOpen] = useState(false); // State for open/close
    const userContext = useContext(UserContext);
    // @ts-ignore
    const coinProps = userContext.get_selected_coin_props();
    const tokenName = coinProps.name;
    const tokenid = coinProps.tokenid;
    const prefix = '/wallet/' + tokenid + '/admin';

    const togglePanel = () => setIsOpen(!isOpen); // Toggle open/close
    
    //  Arrow icon based on state 
    // const arrowIconJSX = <i className={`fas fa-angle-${isOpen ? 'up' : 'down'}`} />
    // const arrowIconJSX = (
    //     <i className={`fas fa-angle-${isOpen ? 'up' : 'down'} arrowIcon ${isOpen ? 'up' : 'down'}`} />
    // );
    const arrowIconJSX = ( <i
            className={`fas fa-angle-down`}
            style={{
                transition: 'transform 0.3s ease',
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', // Rotate based on state
            }}
        /> );

    return (
        <section id="menuAdminSection" className="menuSection" style={{
            transition: "height 0.3s ease",
        }}>
            <div className="sectionHeader" style={{
                border: "0",
                marginBottom: "0",
                paddingBottom: "0",
                fontSize: "15px"
            }}>
                <div style={{ width: "10px" }} /> {/* spacer */}
                <span className="sectionTitle" onClick={togglePanel} style={{ cursor: 'pointer' }}>
                    &nbsp; {arrowIconJSX} &nbsp; Admin Panel 
                </span>
            </div>
            {isOpen && ( // Only show menu when open
                <Menu
                    mode="inline"
                    theme="dark"
                    selectedKeys={selectedKey ? [selectedKey] : []}
                    onSelect={({ key }) => onItemSelect?.(key)}
                    items={[
                        { key: prefix + '/mint', icon: <CubeIcon />, label: 'Mint' },
                        { key: prefix + '/mintuples', icon: <CubesIcon />, label: 'Mintuples' },
                        { key: prefix + '/global-burn', icon: <WalletFireIcon />, label: 'Global Burn' },
                        { key: prefix + '/burn', icon: <FireFlameIcon />, label: 'Burn' },
                        { key: prefix + '/revoke-backup', icon: <ShieldIcon />, label: 'Revoke Backup' },
                        { key: prefix + '/create-contracts', icon: <ContainerFilled />, label: 'Create Contracts' },
                    ]}
                />
            )}
        </section>
    );
};